export default __webpack_public_path__ + "static/member3-907f448b9bc5b765e22290d48e3c302d.png";